import HelpIcon from 'assets/icons/help.svg';
import CustomTooltip from 'components/Tooltip';

interface SwitchProps {
  id: string;
  value: boolean;
  options: string[];
  disabled?: boolean;
  bgColors?: string[];
  handleChange: (value: boolean) => void;
}

const Switch = ({
  id,
  value,
  options,
  bgColors,
  disabled,
  handleChange
}: SwitchProps) => {
  return (
    <div
      className={`flex items-centr justify-between gap-1 min-w-[290px] h-10 p-1 rounded-full border border-gray-300 select-none${
        disabled ? ' cursor-not-allowed' : ' cursor-pointer'
      }`}
    >
      <div
        onClick={() => handleChange(false)}
        className={`flex items-center justify-center flex-1 rounded-full text-black${
          !value
            ? bgColors && bgColors?.length > 0
              ? ` ${bgColors?.[0]}`
              : ' bg-gray-300'
            : 'dark:text-white'
        } ${disabled ? 'opacity-50' : ''}`}
      >
        {options[0]}
      </div>

      <div
        onClick={() => handleChange(true)}
        className={`flex items-center justify-center flex-1 rounded-full text-black${
          value
            ? bgColors && bgColors?.length > 0
              ? ` ${bgColors?.[1]}`
              : ' bg-gray-300'
            : 'dark:text-white'
        } ${disabled ? 'opacity-50' : ''}`}
      >
        {options[1]}
      </div>
      {disabled && (
        <CustomTooltip
          icon={HelpIcon}
          id={`switch-disabled-${id}`}
          className='w-6 h-6 cursor-default mt-1 mr-3'
          content="There's not enough data to apply this switch. We set a minimum sample size in order to maintain data fidelity and privacy."
        />
      )}
    </div>
  );
};

export default Switch;
